export function DtoResUpdateInfo() {
    return {
        codigo: -1,
        mensaje: "",
        mensajeExtra: "",
        data: "",
        dataExtra: ""
    }
}